/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { AppState } from "Dataflows/Reducers";
import {
  ICountryRegionDataState,
  ICountryRegionData,
  ICountryRegionOptionList,
} from "../../Interfaces/SiteContent";

/**
 * Country Region data selector.
 */
export const getCountryRegions = (state: ICountryRegionDataState): ICountryRegionData[] =>
  state.countryRegions;

/**
 * Country Region option list data selector.
 */
export const getCountryRegionsOptionList = (
  state: ICountryRegionDataState
): ICountryRegionOptionList[] => state.countryRegionOptionList;

/**
 * Country Region option list data selector.
 */
export const getAppStateCountryRegionsOptionList = (state: AppState): ICountryRegionOptionList[] =>
  state.countryRegionDataState.countryRegionOptionList;

export const getCountryRegionPhoneOptionList = (
  state: ICountryRegionDataState
): ICountryRegionOptionList[] => state.countryRegionPhoneOptionList;

export const getAppStateCountryRegionPhoneOptionList = (
  state: AppState
): ICountryRegionOptionList[] => state.countryRegionDataState.countryRegionPhoneOptionList;

/**
 * Country Region option list data selector.
 */
export const getCountryRegionLoadError = (state: ICountryRegionDataState): string =>
  state.countryRegionLoadError;

export const getAppStateCountryRegionLoadError = (state: AppState): string =>
  state.countryRegionDataState.countryRegionLoadError;
